import http from "./Http";

export default {
  //AIzaSyDvFCSCtnDR7fjAluBEkOdzcJIM_35h7UM
  getSubscription(type, user) {
    var url = `/v1/vas/${type}/subscriptions?user=${user}`

    return http
      .get(url)
      .then(response => {
        if (response.data.code && response.data.code != 0)
          throw new Error(response.data.message);

        return response.data.result;
      })
      .catch(e => {
        throw e.message;
      });
  },
    getSubscriptionByImei(type, imei) {
        var url = `/v1/vas/${type}/subscriptions?imei=${imei}`

        return http
            .get(url)
            .then(response => {
                if (response.data.code && response.data.code != 0)
                    throw new Error(response.data.message);

                return response.data.result;
            })
            .catch(e => {
                throw e.message;
            });
    },
      loadGeoJSON() {

          var url = "/rcl/index.json"

          return http
              .get(url,{timeout:60000})
              .then(response => {
                    return response.data

              }).catch(e => {
                  console.log("ERROR loadGeoJSON",e)
                  throw e.message;
              });


      }
}
   